<template>
  <div>
    <el-dialog
      :visible.sync="agreeDialog"
      width="700px"
      :close-on-click-modal="false"
    >
      <div class="confirm-info">当前账户尚未注册，是否前往注册？</div>

      <div class="dialog-form">
        <div class="dialog-btns">
          <el-button class="cancel" @click="agreeDialog = false"
            >取消</el-button
          >
          <el-button
            class="confirm"
            @click="
              emilVisible = false;
              $router.push('/register?phone=' + emilData.emil);
            "
            >提交</el-button
          >
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :destroy-on-close="true"
      :visible.sync="emilVisible"
      width="700px"
      :close-on-click-modal="false"
      @closed="closeEmil"
      :show-close="false"
    >
      <!-- 
      <div slot="title" class="dialog-title">
        <span>绑定微信号</span>
      </div> -->

      <div
        style="
          width: 100%;
          text-align: right;
          color: #999;
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
        slot="title"
      >
        <span style="font-size: 30px; color: #000">绑定已有账号</span>
        <i class="el-icon-close" style="cursor: pointer" @click="closeLog"></i>
      </div>

      <div class="dialog-form">
        <el-form :model="emilData" ref="elfrom" :rules="emilRules">
          <el-form-item prop="emil">
            <el-input
              v-model="emilData.emil"
              placeholder="请输入手机号"
            ></el-input>
          </el-form-item>
          <el-form-item prop="code">
            <div style="display: flex; width: 100%">
              <el-input
                v-model="emilData.code"
                placeholder="请输入图形验证码"
              ></el-input>
              <div class="verify-img">
                <img @click="getImgCode" :src="emilData.codeImg" alt="" />
              </div>
            </div>
          </el-form-item>

          <el-form-item prop="elCode">
            <div style="display: flex; width: 100%">
              <el-input
                v-model="emilData.elCode"
                placeholder="请输入验证码"
              ></el-input>
              <div
                v-loading="isloading"
                @click="getEmilCode"
                :class="sendMsgDisabled2 ? 'verify-img1' : 'verify-img'"
                style="text-align: center; line-height: 40px; color: white"
              >
                <span v-if="!sendMsgDisabled2">获取验证码</span>
                <!--                 
                 <div class="verify-text disable" v-if="sendMsgDisabled">
              重新获取 ({{ codeTime }}s)
            </div> -->

                <span v-if="sendMsgDisabled2">
                  重新获取 ({{ codeTime2 }}s)
                </span>
              </div>
            </div>
          </el-form-item>

          <div class="dialog-btns">
            <el-button class="cancel" @click="closeLog">取消</el-button>
            <el-button class="confirm" @click="subSetEmil">提交</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import userApi from "../../../api/user.js";
export default {
  name: "rsaCode",
  props: ["rsaCode"],
  data() {
    return {
      agreeDialog: false,
      isloading: false,
      codeTime2: 59, //邮箱 发送验证码倒计时
      sendMsgDisabled2: false, //邮箱 是否显示获取验证码按钮
      emilVisible: false,
      messageCodeKey: "",
      emilRules: {
        code: [
          { required: true, trigger: "blur", message: "请输入图形验证码" },
        ],
        elCode: [{ required: true, trigger: "blur", message: "请输入验证码" }],
        emil: [
          { required: true, trigger: "blur", message: "请输入手机号" },
          {
            pattern: /^1[0123456789]\d{9}$/,
            message: "请输入正确手机号",
            trigger: ["blur", "change"],
          },
        ],
      },
      emilData: {
        elCode: "",
        emil: "",
        codeImg: "",
        codeKey: "",
      },
    };
  },
  mounted() {},
  methods: {
    closeLog() {
      this.emilVisible = false;
      this.$emit("closeLog");
    },
    ishow() {
      this.emilVisible = true;
      this.getImgCode();
    },
    getImgCode() {
      userApi.imgcod({ channel: "pc" }).then((res) => {
        this.emilData.codeImg = res.data.base64Image;
        this.emilData.codeKey = res.data.codeKey;
      });
    },
    subSetEmil() {
      this.emilRules.elCode[0].required = true;

      this.$refs["elfrom"].validate((valid) => {
        if (valid) {
          let params = {
            messageCodeKey: this.messageCodeKey,
            telephone: this.emilData.emil, //手机号
            messageCode: this.emilData.elCode, //短信验证码
          };
          if (params.messageCodeKey == "") {
            this.$message.error("请先获取验证码");
            return;
          }
          if (this.rsaCode) {
            params["unionId"] = this.rsaCode;
          }
          userApi.bindingWeChat(params).then((res) => {
            if (res.code == 200) {
              if (sessionStorage.getItem("href")) {
                this.$message.success("登录成功");
                let a = JSON.parse(
                  JSON.stringify(sessionStorage.getItem("href"))
                );
                this.$store.dispatch("user/login", data.data).then((e) => {
                  sessionStorage.removeItem("href");
                  window.location.href = a;
                });

                return;
              }

              this.agreeDialog = false;
              this.$store.dispatch("user/login", res.data);
              this.$message.success("登录成功");
            } else {
              this.$message({
                message: res.msg,
                type: "error",
              });
            }
            console.log(res);
          });
        }
      });
    },
    closeEmil() {
      this.emilData = {
        elCode: "",
        emil: "",
        codeImg: "",
        codeKey: "",
      };
      this.$refs["elfrom"].resetFields();
    },
    getEmilCode() {
      if (this.sendMsgDisabled2) {
        return;
      }
      this.emilRules.elCode[0].required = false;
      this.$refs["elfrom"] // 获取验证码
        .validate((valid, obj) => {
          console.log(obj);
          if (valid) {
            this.isloading = true;
            userApi
              .getPhoneCode({
                phone: this.emilData.emil,
                operationType: 1,
                verificationCode: this.emilData.code,
                verificationCodeKey: this.emilData.codeKey,
              })
              .then((res) => {
                if (res.code == 4000012) {
                  this.agreeDialog = true;
                  return;
                }

                if (res.code == 200) {
                  this.$message.success(res.data.msg);
                  this.messageCodeKey = res.data.codeKey;
                  var _this = this;
                  _this.sendMsgDisabled2 = true;
                  let codeInterval2 = window.setInterval(function () {
                    if (_this.codeTime2-- <= 0) {
                      _this.codeTime2 = 59;
                      _this.sendMsgDisabled2 = false;
                      window.clearInterval(codeInterval2);
                    }
                  }, 1000);
                } else {
                  this.$message.error(res.msg);
                  this.getImgCode();
                }
              })
              .finally((e) => {
                this.isloading = false;
              });
          }
        });
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.path {
  stroke: #008077;
}

.dialog-title {
  text-align: left;
  font-size: 30px;
  color: #000;
  border-bottom: 4px solid #e5e5e5;
  width: calc(100% + 40px);
  margin-left: -20px;
  padding-bottom: 20px;
  padding-left: 60px;
  position: relative;

  span {
  }

  &::before {
    display: block;
    content: "";
    width: 65px;
    height: 4px;
    background-color: var(--ThemeColor);
    position: absolute;
    bottom: -4px;
    left: 60px;
  }
}

.dialog-form {
  padding: 0 60px;
  text-align: left;

  .get-verify {
    width: 100%;
    background-color: #3c4250;
    color: var(--textWhite);
  }

  .dilog-select {
    width: 100%;
  }

  .dialog-btns {
    text-align: center;

    .cancel,
    .confirm {
      font-size: 16px;
    }

    .confirm {
      color: var(--textWhite);
      background-color: var(--ThemeColor);
    }
  }
}

.verify-img1 {
  margin-left: 20px;
  width: 150px;
  height: 40px;
  // background-color: #3c4250;
  background-color: var(--textGray);
  border-radius: 3px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
  }

  cursor: pointer;
}
.verify-img {
  margin-left: 20px;
  width: 150px;
  height: 40px;
  // background-color: #3c4250;
  background-color: var(--ThemeColor);
  border-radius: 3px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
  }

  cursor: pointer;
}

.login-con {
  margin: 77px auto;
}

.center-dialog {
  top: 50%;
  transform: translateY(-50%);
}

.bgred {
  border: 1px solid red;
}

.confirm-info {
  font-size: 26px;
  color: #000;
  margin-bottom: 30px;
}

.dialog-title {
  text-align: left;
  font-size: 30px;
  color: #000;
  border-bottom: 4px solid #e5e5e5;
  width: calc(100% + 40px);
  margin-left: -20px;
  padding-bottom: 20px;
  padding-left: 60px;
  position: relative;

  span {
  }

  &::before {
    display: block;
    content: "";
    width: 65px;
    height: 4px;
    background-color: var(--ThemeColor);
    position: absolute;
    bottom: -4px;
    left: 60px;
  }
}

.dialog-form {
  padding: 0 60px;
  text-align: left;

  .get-verify {
    width: 100%;
    background-color: #3c4250;
    color: var(--textWhite);
  }

  .dilog-select {
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/login/components/phone.vue